import React, { useEffect, useState, useContext } from "react";
import axios from 'axios';
import Header from "../components/dashboard/header";
import Footer from "../components/dashboard/footer";
// import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "../pages/student/SideMenu";
import { contentContext } from "../context/contentContext";
import { useNavigate } from "react-router-dom";
import tmdbApi from "../api/tmdbApi";
import SweetAlert from 'react-bootstrap-sweetalert';
import Loader from "../components/loader";
// import Sidebar from "../components/dashboard/sidebar";


const SubscriptionPlans = () => {
    const [selectedPlanIndex, setSelectedPlanIndex] = useState(0); // default to first plan selected
    const navigate = useNavigate();
    const [plans, setPlans] = useState([])
    const [subscriptionsData, setSubscriptionsData] = useState([]);
    const [editedData, setEditedData] = useState({});
    const [popup, setPopup] = useState(false);
    const [features, setFeatures] = useState([]);
    const [errors, setErrors] = useState({});
    const [alertMsg, setAlertMsg] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading,setShowSessionPopupup, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const getPlans = async () => {
        let planstmp = await tmdbApi.getPlans();
        setSubscriptionsData(planstmp?.result || [])
        setEditedData({})
        console.log("planstmp", planstmp?.result)
    }
    const amoutFrmt = (amount) => {
        const formattedAmount = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            maximumFractionDigits: 0,
        }).format(amount);
        return formattedAmount;
    }
    const handleEdit = (id) => {
        console.log("IdDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD", id)
        const filterData = subscriptionsData?.find((item) => item?.subscriptionplanid === id);
        console.log("filterDatatatata", filterData);  // This will print the object directly
        setEditedData(filterData)
        setFeatures(filterData?.points)
        setErrors({})
    }
    //  const handleChange = (event, id) => {
    //     const { name, value } = event.target;
    // console.log("editedDatattata---->",editedData?.planid)
    // console.log("Iddddddddddddddddddddddddddd",id)

    //         setEditedData((prevData) => ({
    //             ...prevData,
    //             [name]: Number(value) || value,  // Update the edited field dynamically; if it's a number, store it as a number
    //         }));
    //         setErrors(prevErrors => {
    //             const updatedErrors = { ...prevErrors };
    //             delete updatedErrors[name]; // Remove the error for the current field only
    //             return updatedErrors;
    //         });
    // };

    const handleChange = (event, id) => {
        const { name, value } = event.target;

        // Make sure we're editing the correct plan
        if (editedData?.subscriptionplanid !== id) return;

        setEditedData((prevData) => ({
            ...prevData,
            [name]: name === "price" ? Number(value) : value, // Convert price to number only
        }));

        setErrors(prevErrors => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });
    };

    const handleInputChange = (e, index) => {
        const { value } = e.target;

        // Update specific index in features array
        const updatedFeatures = [...features];
        updatedFeatures[index] = value;

        setFeatures(updatedFeatures);

        // Optional: Update editedData if needed
        setEditedData(prev => ({
            ...prev,
            points: updatedFeatures
        }));
    };






    const handleStatusChange = (e, item) => {
        const isChecked = e.target.checked;

        setEditedData(prevData => ({
            ...prevData,
            status: isChecked ? "ACTIVE" : "INACTIVE"
        }));

        console.log(`Status changed to: ${isChecked ? "ACTIVE" : "INACTIVE"}`);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getPlans()
    }, []);
    // console.log("featuresssssssssssssssssssssssssssssssss",features)
    // const plans = [
    //     {
    //         price: "₹ 75,000",
    //         duration: "3 Months Plan",
    //         description: "For most businesses that want to optimize web queries",
    //         points: [
    //             "Full slide collection",
    //             "3 Modules",
    //             "Join ongoing 12/24-month lectures (1 lecture/week)",
    //             "Weekly case discussions",
    //             "CPC Participation",
    //             "1 Mentorship session/mo",
    //             "Certificate of Completion",
    //             "Rolling enrollment",
    //         ],
    //     },
    //     {
    //         price: "₹ 1,40,000",
    //         duration: "6 Months Plan",
    //         description: "For most businesses that want to optimize web queries",
    //         points: [
    //             "Full slide collection",
    //             "6 Modules",
    //             "Join ongoing 12/24-month lectures (1 lecture/week)",
    //             "Weekly case discussions",
    //             "CPC Participation",
    //             "2 Mentorship session/mo",
    //             "Certificate of Completion",
    //             "Rolling enrollment",
    //         ],
    //     },
    //     {
    //         price: "₹ 2,50,000",
    //         duration: "12 Months Plan",
    //         description: "For most businesses that want to optimize web queries",
    //         points: [
    //             "Full slide collection",
    //             "All Modules",
    //             "Join ongoing 12/24-month lectures (1 lecture/week)",
    //             "Weekly case discussions",
    //             "CPC Participation",
    //             "4 Mentorship session/mo",
    //             "Certificate (Pass/Distinction)",
    //             "Set start date TBD",
    //         ],
    //     },
    //     {
    //         price: "₹ 4,50,000",
    //         duration: "24 Months Plan",
    //         description: "For most businesses that want to optimize web queries",
    //         points: [
    //             "Full slide collection",
    //             "All Modules + archives",
    //             "1 lecture/week",
    //             "Monthly CPCs",
    //             "Weekly case discussions",
    //             "8 Mentorship session/mo",
    //             "Lecture library access/mo",
    //             "Research opportunity",
    //             "Certificate (Pass/Distinction)",
    //             "Set start date TBD",
    //         ],
    //     },
    // ];
    const handlecancel = () => {
        if (userData?.userType === "DOCTOR") {
            navigate("/lecture-library")
        } else {
            navigate("/dashboard")
        }


    }
    console.log("editedDatatatatata", editedData)
    const handleSave = async () => {
        if (validateInputs()) {
            console.log("Validation passed. You can proceed with saving.");

            GetTimeActivity()
            // setBtnLoader(true)

            const token = localStorage.getItem("token")
            let payload = {}
            payload = {

                ...editedData

            }

            delete payload._id;
            delete payload.planid;

            try {
                const response = await tmdbApi.updatePlans(payload)

                if (response?.data?.result === "Invalid token or Expired") {
                     setShowSessionPopupup(true);
                } else {
                    // setBtnLoader(false);
                    console.log("response", response?.data);
                    await getPlans(); // Assuming this is async
                    setPopup(true);
                }
            } catch (error) {
                console.error("Error updating subscription:", error);
                // setBtnLoader(false);
                // Optionally: show error message
            }


            // Add your save logic here.
        } else {
            console.log("Validation failed. Please correct the errors.");
        }
    };
    const validateInputs = () => {
        const newErrors = {};

        // Ensure at least 5 features to check
        const firstFive = features.slice(0, 5);

        const isAnyEmpty = firstFive.some(point => !point || point.trim() === "");

        // Validate price
        if ((editedData?.subscriptionplanid && !editedData?.price) || editedData?.price === 0) {
            newErrors['price'] = "Price is required";
        }

        // Validate first 5 feature points
        if (isAnyEmpty) {
            setAlertMsg(true); // You can show alert UI based on this state
            newErrors['features'] = "First 5 features are required.";
        }

        // Set collected errors
        setErrors(newErrors);

        // Return true if no errors
        return Object.keys(newErrors).length === 0;
    };

    return (
        <div id="layout-wrapper">
            <Header />
         <SideMenu />

            <div className="main-content user-management subscription-page subscription-page-plan" id="main-content">
                <div className="page-content" id="page-content">
                    {/* <div className="container-fluid d-flex justify-content-end pe-0 me-0 pb-3" id="container-fluid">
                        <button className="create-quiz-btn border-0" onClick={handlecancel}>Cancel</button>
                    </div> */}
                    <div className="row table-data" id="table-data-row">
                        <div className="col-12">
                            <div className="card" id="card">
                                <div className="card-body" id="card-body">
                                    <div className="cpc-subscription ps-2 pe-2">
                                        <div className="cpc-subscription-heading container">
                                            <p className="adv_lrn">CPC Subscription</p>
                                            <h3 className="sub_title">DADI Online Dermatopathology Fellowship</h3>
                                            <p className="txt-16 text-muted cpc-head-para">
                                                <span>Flexible training program with tiered options.</span>
                                                All tiers include access to <span className="d-block">the full slide collection.</span>
                                            </p>
                                        </div>

                                        {/* <div className="cpc-subscription-section">
                                            <div className="row plans">
                                                {plans.length>0 && plans.map((plan, index) => (
                                                    <div className="col-md-3" key={index}>
                                                        <div className={`basic_plan ${selectedPlanIndex === index ? "active_plan" : ""}`}>
                                                            <h6 className="price-txt">{amoutFrmt(plan.price)}</h6>
                                                            <h6 className="months-plan-txt">{plan.duration}</h6>
                                                            <p className="plan-desc">{plan.description}</p>
                                                            {plan.points.map((point, idx) => (
                                                                <div className="points" key={idx}>
                                                                    <span className="material-symbols-outlined check-icons">chevron_right</span>
                                                                    <p>{point}</p>
                                                                </div>
                                                            ))}
                                                            <div className="Plan-select-footer">
                                                                <button
                                                                    className={`stroke-btn ${selectedPlanIndex === index ? "fill-btn" : ""}`}
                                                                    onClick={() => {
                                                                        setSelectedPlanIndex(index)
                                                                        navigate("/billingpage/"+plan?.subscriptionplanid)
                                                                    }}
                                                                >
                                                                    Select
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div> */}
                                        <div className="subscription-plan">
                                            <div className="row">
                                                {/* basic plan */}
                                                {subscriptionsData?.map((item, index) => {
                                                    return (
                                                        <div className="col-lg-3 col-md-6 col-sm-12" key={item?.subscriptionplanid}>
                                                            <div className="store_block subscription-wrapper" id={`plan-wrapper-${item?.subscriptionplanid}`}>
                                                                <div className="d-flex justify-content-end">
                                                                    <div
                                                                        // className={subValDashboard && subValDashboard.edit && subValDashboard.edit.enable === true ? "d-flex edit-delete-option" : "d-flex edit-delete-option pe-none"}
                                                                        className="edit-delete-option sub-plan-edit"
                                                                        onClick={() => handleEdit(item?.subscriptionplanid)}
                                                                        id={`edit-option-${item?.subscriptionplanid}`}
                                                                    >
                                                                        <span className="material-symbols-outlined edit-icon sub-plan-edit-icon">edit</span>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex sub-header flex-column align-items-start position-relative mb-3">
                                                                    {/* <h3 className="sm-heading" id={`plan-name-${item?.subscriptionplanid}`}>
                                {amoutFrmt(item?.price)}
                            </h3> */}
                                                                    <label className="form_label label-width" id={`price-label-${item?.subscriptionplanid}`}>PLAN PRICE<span className="required">*</span></label>
                                                                    <input
                                                                        className="form-control"
                                                                        placeholder="Enter Price"
                                                                        name="price"
                                                                        value={
                                                                            editedData?.subscriptionplanid === item?.subscriptionplanid
                                                                                ? editedData?.price
                                                                                : item?.price
                                                                        }
                                                                        onChange={(e) => handleChange(e, item?.subscriptionplanid)}

                                                                        disabled={item?.subscriptionplanid !== editedData?.subscriptionplanid}
                                                                        id={`price-input-${item?.subscriptionplanid}`}
                                                                    />
                                                                    {item?.subscriptionplanid === editedData?.subscriptionplanid && errors['price'] && (
                                                                        <span className="error-message" style={{ color: "red", margin: "0px", fontSize: "10px" }} id={`error-price-${item?.subscriptionplanid}`}>
                                                                            {errors['price']}
                                                                        </span>
                                                                    )}
                                                                    {/* <div className="input-field switch-buttons d-flex align-items-center">
                                <label className="col-form-label p-0 me-2" id={`active-label-${item?.subscriptionplanid}`}>Active</label>
                                <label className="switch disable mb-0">
                                    <input
                                        type="checkbox"
                                        checked={editedData?.subscriptionplanid === item?.subscriptionplanid ? editedData?.status === "ACTIVE" : item?.status === "ACTIVE"}
                                        onChange={(e) => handleStatusChange(e, item)}
                                        disabled={item?.subscriptionplanid !== editedData?.subscriptionplanid}
                                        id={`checkbox-${item?.subscriptionplanid}`}
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div> */}
                                                                    {/* {subValDashboard && subValDashboard.edit && subValDashboard.edit.display === true && ( */}

                                                                    {/* )} */}
                                                                </div>

                                                                <div>
                                                                    {/* PLAN PRICE */}
                                                                    {/* <div className="input-group mt-3 mb-3">
                                <label className="form_label label-width" id={`price-label-${item?.planid}`}>PLAN PRICE<span className="required">*</span></label>
                                <div className="d-flex gap-3 input-flex">
                                    <div className="input-group input-width-1">
                                        <input
                                            className="form-control input-border"
                                            placeholder="$00"
                                            onKeyDown={(e) => { // Prevent decrement when using arrow keys
                                                if (e.key === 'ArrowDown') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            value={editedData?.planid === item?.planid ? editedData?.monthly : item?.monthly}
                                            type="number"
                                            name="monthly"
                                            disabled={item?.planid !== editedData?.planid}
                                            onChange={handleChange}
                                            id={`monthly-input-${item?.planid}`}
                                        />
                                        <span className="input-group-text month-text" id={`monthly-text-${item?.planid}`}>Per Month</span>
                                    </div>
                                    <div className="input-group input-width-2">
                                        <input
                                            className="form-control input-border"
                                            placeholder="$00"
                                            type="number"
                                            value={editedData?.planid === item?.planid ? editedData?.yearly : item?.yearly}
                                            onKeyDown={(e) => { // Prevent decrement when using arrow keys
                                                if (e.key === 'ArrowDown') {
                                                    e.preventDefault();
                                                }
                                            }}
                                            name="yearly"
                                            disabled={item?.subscriptionplanid !== editedData?.subscriptionplanid}
                                            onChange={handleChange}
                                            id={`yearly-input-${item?.subscriptionplanid}`}
                                        />
                                        <span className="input-group-text month-text" id={`yearly-text-${item?.subscriptionplanid}`}>Per Year</span>
                                    </div>
                                </div>
                            </div>
                            {item?.subscriptionplanid === editedData?.subscriptionplanid && errors['monthly_yearly'] && (
                                <span className="error-message" style={{ color: "red", margin: "0px", fontSize: "10px" }} id={`error-monthly-yearly-${item?.planid}`}>
                                    {errors['monthly_yearly']}
                                </span>
                            )} */}

                                                                    {/* PLAN DESCRIPTION */}
                                                                    <div className="input-group mb-1 justify-content-center">
                                                                        <h3 className="plan_name" id={`description-label-${item?.subscriptionplanid}`}>{item?.duration}
                                                                        </h3>
                                                                    </div>

                                                                    {/* {item?.planid === editedData?.subscriptionplanid && errors['tagline'] && (
                                <span className="error-message" style={{ color: "red", margin: "0px", fontSize: "10px" }} id={`error-tagline-${item?.planid}`}>
                                    {errors['tagline']}
                                </span>
                            )} */}
                                                                </div>

                                                                <div className="sub-section">
                                                                    {/* Brand Manager */}




                                                                    {(() => {
                                                                        const moreFeatures = item?.points || [];

                                                                        return (
                                                                            <>
                                                                                {moreFeatures.length > 0 && (
                                                                                    <>
                                                                                        {moreFeatures?.map((point, index) => (
                                                                                            <div key={index} className="input-group mb-3 input-style-flex">
                                                                                                <input
                                                                                                    className="form-control"
                                                                                                    type="text"
                                                                                                    value={editedData?.subscriptionplanid === item?.subscriptionplanid
                                                                                                        ? features[index] ?? point
                                                                                                        : point
                                                                                                    }
                                                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                                                    disabled={editedData?.subscriptionplanid !== item?.subscriptionplanid}
                                                                                                    id={`point-input-${item?.subscriptionplanid}-${index}`}
                                                                                                />
                                                                                            </div>
                                                                                        ))}

                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        );
                                                                    })()}

                                                                    {/* Buttons */}
                                                                    <div className="mt-3 d-flex justify-content-start">
                                                                        <button
                                                                            className="fill-btn-style"
                                                                            disabled={item?.subscriptionplanid !== editedData?.subscriptionplanid
                                                                                // ||BtnLoader
                                                                            }
                                                                            onClick={handleSave}
                                                                            id={`save-btn-${item?.subscriptionplanid}`}
                                                                        >
                                                                            {/* {item.planid === editedData?.planid && BtnLoader ? (
                                        <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" />
                                    ) : null} */}
                                                                            SAVE
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="cpc-points">
                                            <p className="txt-16 cpc-head-para">Eligibility: <span>“MD/DNB Dermatologists & Pathologists only.”</span></p>
                                            <p className="txt-16 cpc-head-para">Subscription: <span>Monthly billing; 30-day cancellation notice for 3/6-month tiers; 12/24-month tiers offer 2 or 4 installments.</span></p>
                                            <p className="txt-16 cpc-head-para">Start Date: 3/6 months: <span>Enroll anytime, begins upon payment; 12/24 months: Set cohort start date (TBD).</span></p>
                                            <p className="txt-16 cpc-head-para">CTA: <span>“Apply Now” form (name, email, CV upload, statement of purpose, select tier).</span></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SweetAlert
                            show={popup}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Plan Updated Successfully"}
                            onConfirm={e => setPopup(false)}
                            id="error-alert"
                        ></SweetAlert>
                        <SweetAlert
                            show={alertMsg}
                            custom
                            confirmBtnText="ok"
                            confirmBtnBsStyle="primary"
                            title={"Please Atleast Add First Four Features"}
                            onConfirm={e => setAlertMsg(false)}
                            id="error-alert"
                        ></SweetAlert>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default SubscriptionPlans;
